/*跨域地址*/
let dev = process.env.dev;
dev = dev + "/c";

export default {
  /** 服务单确认完成*/
  confirmOrder: {
    url: dev + "/sv/order/confirm",
    method: "post",
  },
  /**删除服务单 */
  deleteOrder: {
    url: dev + "/sv/order/delete",
    method: "post",
  },
  /**查看评价 */
  getOrderScore: {
    url: dev + "/sv/score",
    method: "get",
  },
  /**评价订单 */
  createOrderScore: {
    url: dev + "/sv/score",
    method: "post",
  },
  //获取单条自定义服务记录详情
  getCustRecordDetail: {
    url: dev + "/sv/customize/records/details",
    method: "get",
  },
  /** 查询订单渠道来源*/
  getSvorderType: {
    url: dev + "/sv/order/evaluate/source",
    method: "get",
  },
  /** 工作室评分类型与标签查询D*/
  getEvalLabList: {
    url: dev + "/noauth/evaluate/star/type/lab",
    method: "get",
  },
  //评价确认
  getNoauthOrderConfirm: {
    url: dev + "/noauth/order/confirm",
    method: "post",
  },
  //外部转介绍邀请评价
  getNoauthScore: {
    url: dev + "/noauth/score",
    method: "post",
  },
  //检测是否可评价
  getEvalStatus: {
    url: dev + "/noauth/eval/status",
    method: "get",
  },
  /**图片地址转base64*/
  imgTobase: {
    url: dev + "/noauth/url/extend",
    method: "get",
  },
  //预约服务-转介绍渠道浏览记录
  dacOrderIntroduceVisit: {
    url: dev + "/dac/order/introduce/visit",
    method: "post",
  },
  //预约服务-转介绍微信下单
  dacOrderIntroduce: {
    url: dev + "/dac/order/introduce",
    method: "post",
  },
};



// WEBPACK FOOTER //
// ./src/api/order.js